import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { MessageService } from "../components/message/message.service";
import { AuthService } from "src/app/core/services/auth.service";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class PermissionsGuard implements CanActivate {

  private readonly allowedPermissionKeys = [
    108
  ];

  constructor(
    private readonly auth: AuthService,
    private readonly router: Router,
    private readonly messageService: MessageService
  ) {}

  canActivate() {
    const allowed = this.allowedPermissionKeys.every(allowedKey => this.auth.permissions.includes(allowedKey));
    return allowed || this.denyActivate();
  }

  private denyActivate() {
    this.messageService.message$.next({
      icon: 'exclamation',
      body: `
        Напишите в чат поддержки в <br>
        <a href="${ environment.siteUrl }" class="link" target="_blank">личном кабинете</a>, <br>
        чтобы подключить расширение
      `
    });
    return this.router.createUrlTree(['message']);
  }

}
